export interface CustomHistory {
  [secId: string]: {
    [fieldName: string]: number[][];
  };
}

const customHistoryStore: CustomHistory = {};

export { customHistoryStore };
